import inviteBgSrc from "~/assets/img/invite.jpg";
import {IIconBase} from "~/components/icons/_common/types";

interface InviteBgImageProps extends Omit<IIconBase, "size"> {}

export const BmInviteBgImage: React.FC<InviteBgImageProps> = ({id, className}) => {
  return <img src={inviteBgSrc} id={id} alt="Invite bg" className={className} />;
};
